import "instantsearch.css/themes/satellite.css";
import "./App.css";
import {
  InstantSearch,
  SearchBox,
  Configure,
  Hits,
  Pagination,
  RefinementList,
  RangeInput,
} from "react-instantsearch";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  Icon,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useToast,
  Box,
  Text,
} from "@chakra-ui/react";
import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";
import { useGetOrderMediaConfig } from "../views/PlaceOrderTest/queryHooks";
import { useState, useMemo } from "react";
import AddPartQuantityModal from "../views/Orders/components/AddPartQuantityModal";

const FacetedPartSearch = ({
  onClose,
  isOpen,
  orderItems,
  onAddPart,
  remove_idFromPartDetails,
}: any) => {
  const { data: mobileConfigs } = useGetOrderMediaConfig();
  const toast = useToast();

  const [selectedPart, setSelectedPart] = useState<any | null>(null);
  const [isQuantityModalOpen, setIsQuantityModalOpen] = useState(false);
  const [quantity, setQuantity] = useState<string>("1");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const typesenseInstantsearchAdapter = useMemo(() => {
    return new TypesenseInstantSearchAdapter({
      server: {
        nodes: [
          {
            host: mobileConfigs?.typesense_host,
            port: 443,
            protocol: "https",
          },
        ],
        apiKey: mobileConfigs?.typesense_api_key,
      },
      additionalSearchParameters: {
        query_by: "partName,partNumber",
      },
    });
  }, [mobileConfigs]);

  const handleConfirmAdd = async () => {
    if (!selectedPart || !onAddPart) return;

    const quantityNum = parseInt(quantity);
    if (isNaN(quantityNum) || quantityNum < 1) {
      toast({
        description: "Quantity must be at least 1",
        status: "error",
        position: "top",
      });
      return;
    }

    try {
      setIsSubmitting(true);
      await onAddPart(selectedPart, quantityNum);

      toast({
        description: "Part added successfully",
        status: "success",
        position: "top",
      });

      setIsQuantityModalOpen(false);
      setSelectedPart(null);
      setQuantity("1");
    } catch (error: any) {
      toast({
        description:
          error?.response?.data?.errorMsg ||
          error?.response?.data?.message ||
          "Failed to add part. Please try again.",
        status: "error",
        position: "top",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const Hit = ({ hit }: any) => {
    const alreadyExists = orderItems?.some(
      (item: any) => item.partId === (hit._id || hit.partId),
    );

    return (
      <Box
        className="hit"
        onClick={() => {
          if (!alreadyExists) {
            setSelectedPart(hit);
            setQuantity("1");
            setIsQuantityModalOpen(true);
          }
        }}
        cursor={alreadyExists ? "not-allowed" : "pointer"}
        position="relative"
        padding="12px"
        borderRadius="8px"
        transition="all 0.2s"
        _hover={!alreadyExists ? { backgroundColor: "#F0F6F6" } : {}}
        width="100%"
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <div className="hit-content">
          <Text fontSize="sm">{hit.partName}</Text>
          <Text fontSize="sm">{hit.partNumber}</Text>
          <Text fontSize="sm">{hit.brand}</Text>
          <Text fontSize="sm" color="blue.600">
            ₹{hit.mrp}
          </Text>
        </div>
        {alreadyExists && (
          <Text
            color="red.500"
            fontSize="sm"
            fontWeight="bold"
            position="absolute"
            right={2}
            top={2}
          >
            Already Exists
          </Text>
        )}
      </Box>
    );
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={"full"}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader display={"flex"} justifyContent={"space-between"}>
          Part Search
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <div>
            <InstantSearch
              indexName="partmasters"
              searchClient={typesenseInstantsearchAdapter.searchClient}
            >
              <Configure ruleContexts={[]} />
              <div className="container-1">
                <div className="facets">
                  <div className="facet">
                    <h2>Brands</h2>
                    <RefinementList
                      attribute="brand"
                      searchable={true}
                      searchablePlaceholder="Search brands"
                      showMore={true}
                    ></RefinementList>
                  </div>

                  <div className="facet">
                    <h2>Origin</h2>
                    <RefinementList attribute="origin"></RefinementList>
                  </div>
                </div>

                <div className="search-results">
                  {" "}
                  <SearchBox autoFocus />
                  <Configure hitsPerPage={20} />
                  <Hits hitComponent={Hit} />
                  <Pagination className="Pagination" />
                </div>
              </div>
            </InstantSearch>
          </div>
        </ModalBody>

        <ModalFooter></ModalFooter>
      </ModalContent>
      <AddPartQuantityModal
        isOpen={isQuantityModalOpen}
        onClose={() => setIsQuantityModalOpen(false)}
        selectedPart={selectedPart}
        quantity={quantity}
        onQuantityChange={setQuantity}
        onConfirm={handleConfirmAdd}
        remove_idFromPartDetails={remove_idFromPartDetails}
        isLoading={isSubmitting}
      />
    </Modal>
  );
};

export default FacetedPartSearch;
